import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React, { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import { useAppDispatch } from "src/app-redux/hooks";
import {
  getRevenueAction,
  getVehicleActionLevelThree,
  getVehicleActionLevelTwo,
} from "src/app-redux/insights/actions/insightsActions";
import { IRevenueInsights } from "src/common/typings/insights";
import { BBFColor } from "../Vehicle/components/utils";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import CommonDialog from "src/components/AlertDialog/CommonDialog";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import moment from "moment";
import "moment-timezone";
import { GridRowModel } from "@material-ui/x-grid";
import { columns } from "./columns";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  startDate: string;
  endDate: string;
}

const useStyles = makeStyles(() => ({
  outer: {
    height: "300px",
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "10px",
  },

  revenueItemsList: {
    maxHeight: "280px",
    overflowY: "auto",
  },
  revenueItem: {
    marginBottom: "10px",
  },
  revenuePercentage: {
    fontSize: "14px",
    // fontWeight: 700,
  },
  itemAmount: {
    fontSize: "13px",
    // color: "#9E9E9E",
  },
  statusItem: {
    borderBottom: "1px solid #E6E6E6",
    padding: "10px 10px",
    // marginBottom: "10px",
  },
  statusAmount: {
    fontSize: "14px",
    textAlign: "right",
  },
  heading: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "15px",
  },
  icons: {
    margin: "1px 10px 15px 0",
    height: "17px",
  },
  revenueAmount: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#488CFB",
    marginBottom: "15px",
  },

  vehiclesItem: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "15px 15px 0 15px",
    marginBottom: "15px",
  },
  scrollbar: {
    height: "35px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: 10,
      height: 10,
    },
  },
}));

export function Revenue({ startDate, endDate }: Props): React.ReactElement {
  const classes = useStyles();
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const [revenueList, setRevenueList] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState<number>(0);

  const [vehiclesLever2List, setVehiclesLevel2List] = useState<any>([]);
  const displayColumns = columns;
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const [vehicleList, setVehicleList] = useState<any>([]);

  const donutChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  const [data, setData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Total Revenue",
        data: [],
        backgroundColor: [],
        borderWidth: 0,
      },
    ],
  });
  const [colors, setColors] = useState<any>([]);
  const dispatch = useAppDispatch();

  const [barChartDataLevel2, setBarChartDataLevel2] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Vehicle Status",
        data: [],
        backgroundColor: "#FFD500",
        borderRadius: 50,
        barThickness: 10,
      },
    ],
  });

  const [isOpenDailogLevelThree, setIsOpenDailogLevelThree] = useState(false);
  const [isOpenDailogLevelTwo, setIsOpenDailogLevelTwo] = useState(false);
  const [chartHeadeingLevel2, setChartHeadeingLevel2] = useState({
    status: "",
    count: "",
  });
  const [chartHeadeingLevel3, setChartHeadeingLevel3] = useState({
    consignmentType: "",
    count: "",
  });
  const [chartHeadeingLevel3Payload, setChartHeadeingLevel3Payload] = useState({
    startDate: startDate,
    endDate: endDate,
    vehicleStatus: "",
    consignmentType: "",
    isBbfVehicle: false,
    isCommercialVehicles: false,
  });
  const toggleDialogLevelTwo = async (vehicle: any, isBbfVehicle: any) => {
    setChartHeadeingLevel2({
      status: vehicle.name,
      count: vehicle?.count,
    });
    getVehicleInsightLevelTwo(startDate, endDate, "", isBbfVehicle, vehicle.isCommercialVehicles);
    setIsOpenDailogLevelTwo(!isOpenDailogLevelTwo);
  };

  const getVehicleInsightLevelTwo = async (
    startDate: string,
    endDate: string,
    vehicleStatus: string,
    isBbfVehicle: any,
    isCommercialVehicles: any
  ) => {
    const req: any = {
      startDate: startDate,
      endDate: endDate,
      vehicleStatus: vehicleStatus,
      isBbfVehicle: isBbfVehicle,
      isCommercialVehicles: isCommercialVehicles,
      isNodRequest: true,
    };
    setChartHeadeingLevel3Payload({
      ...chartHeadeingLevel3Payload,
      vehicleStatus: vehicleStatus,
      isBbfVehicle: isBbfVehicle,
      isCommercialVehicles: isCommercialVehicles,
    });
    const res = await dispatch(getVehicleActionLevelTwo(req));

    if (res.payload) {
      setVehiclesLevel2List(res.payload.vehicleConsignmentStatsModel);
      setBarChartDataLevel2({
        labels: res.payload.vehicleConsignmentStatsModel.map((item: any) => {
          return item.consignmentType;
        }),
        datasets: [
          {
            label: "Vehicle count",
            data: res.payload.vehicleConsignmentStatsModel.map((item: any) => {
              return item.count;
            }),
            backgroundColor: "#FFD500",
            borderRadius: 50,
            barThickness: 10,
          },
        ],
      });
    }
  };

  const barChartOptionsLevel2 = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        min: 0,
        ticks: {
          stepSize: 1,
        },
      },
    },
    onHover: (event: any, chartElement: any) => {
      event.native.target.style.cursor = chartElement.length ? "pointer" : "default";
    },
    onClick: async (chartElement: any) => {
      if (chartElement?.length > 0) {
        const index = chartElement[0]?.index;
        setChartHeadeingLevel3({
          consignmentType: vehiclesLever2List[index]?.consignmentType,
          count: vehiclesLever2List[index]?.count,
        });
        toggleDialogLevelThree();
        setChartHeadeingLevel3Payload({
          ...chartHeadeingLevel3Payload,
          consignmentType: vehiclesLever2List[index]?.consignmentType,
        });
        const { vehicleStatus, isBbfVehicle, isCommercialVehicles } = chartHeadeingLevel3Payload;
        const consignmentType = vehiclesLever2List[index]?.consignmentType;

        getVehicleInsightLevelThree(
          startDate,
          endDate,
          vehicleStatus,
          consignmentType,
          isBbfVehicle,
          isCommercialVehicles
        );
      }
    },
  };

  const toggleDialogLevelThree = async () => {
    setIsOpenDailogLevelThree(!isOpenDailogLevelThree);
  };

  const getVehicleInsightLevelThree = async (
    startDate: string,
    endDate: string,
    vehicleStatus: string,
    consignmentType: string,
    isBbfVehicle: boolean,
    isCommercialVehicles: boolean
  ) => {
    const req: any = {
      StartDate: startDate,
      EndDate: endDate,
      VehicleStatus: vehicleStatus,
      ConsignmentType: consignmentType,
      isBbfVehicle: isBbfVehicle,
      isCommercialVehicles: isCommercialVehicles,
      isNodRequest: true,
    };
    setvehicleRecord([]);
    setLoader(true);
    const res = await dispatch(getVehicleActionLevelThree(req));

    if (res.payload) {
      setvehicleRecord(res?.payload?.gateEnteries);
      setLoader(false);
    }
  };

  useEffect(() => {
    getRevenueInsight(startDate, endDate);
  }, [startDate, endDate]);

  const getNewColorCode: any = () => {
    const colorCode = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
    return colorCode.length == 7 ? colorCode : getNewColorCode();
  };

  const getRevenueInsight = async (startDate: string, endDate: string) => {
    const colors: any = [];
    const req: IRevenueInsights = {
      startDate: startDate,
      endDate: endDate,
      isNodRequest: true,
    };
    const res = await dispatch(getRevenueAction(req));

    if (res.payload) {
      setTotalAmount(
        res.payload.revenueWidget.reduce((partialSum: any, a: any) => partialSum + a.amount, 0)
      );
      setData({
        labels: res.payload.revenueWidget.map((item: any) => {
          return item.paymentType;
        }),
        datasets: [
          {
            label: "Total Revenue",
            data: res.payload.revenueWidget.map((item: any) => {
              return item.amount;
            }),
            backgroundColor: res.payload.revenueWidget.map(() => {
              const colorCode = getNewColorCode();
              colors.push(colorCode);
              return colorCode;
            }),
            borderWidth: 0,
          },
        ],
      });

      setVehicleList(res.payload.revenueVehicles);
      setRevenueList(res.payload.revenueWidget);
      setColors(colors);
    }
  };

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        Vehicle: data?.vehicleNumber,
        Driver: data?.driverName,
        Type: data?.vehicleType,
        Status: data?.vehicleStatus,
        Consignment: data?.consignmentType,
        "GD #": data?.gdNumber,
        Location: data?.terminalLocation,
        Cargo: data?.cargoTypeName,
        Yard: data?.yardName,
        Entry: data.gateEntryDate ? moment(data.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A") : "",
        Checkout: data.gateOutDate ? moment(data.gateOutDate).format("DD-MM-YYYY hh:mm:ss A") : "",
        Anomaly: data.isAnomlyDetected ? "Yes" : "No",
        "In Progress": data.vehicleInProgress ? "Yes" : "No",
      };
    });
    return exportedRecords;
  };

  return (
    <>
      <Grid container direction="row" spacing={3} className={classes.outer}>
        {/* Donut Chart */}
        <Grid item xs={12} md={4}>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box maxWidth={200} maxHeight={200}>
              <Pie data={data} options={donutChartOptions} />
              <Typography
                style={{ textAlign: "center", marginTop: "15px" }}
                variant="h5"
                component="p"
              >
                {totalAmount.toLocaleString(undefined, { maximumFractionDigits: 2 })}{" "}
              </Typography>
              <Typography variant="body1" component="p" style={{ textAlign: "center" }}>
                Total Revenue in PKR
              </Typography>
            </Box>
          </Box>
        </Grid>
        {/* List */}
        <Grid item xs={12} md={4} className={classes.revenueItemsList}>
          {revenueList.map((item: any) => {
            return (
              <>
                <Grid
                  container
                  direction="row"
                  key={item.paymentType}
                  className={classes.revenueItem}
                >
                  <Grid container direction="row" item xs={8}>
                    <div
                      className="colorPicker"
                      style={{
                        width: "20px",
                        height: "20px",
                        margin: "0 10px 14px 0px",
                        borderRadius: "8%",
                        backgroundColor: colors[revenueList.indexOf(item)],
                      }}
                    ></div>
                    <Box>
                      {item.paymentType}
                      <Typography className={classes.itemAmount}>
                        {totalAmount > 0 ? ((item.amount / totalAmount) * 100).toFixed(2) : 0} %
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4} className={classes.revenuePercentage}>
                    {item.currency}{" "}
                    {item.amount.toLocaleString(undefined, { maximumFractionDigits: 2 })}{" "}
                  </Grid>
                </Grid>
              </>
            );
          })}
        </Grid>
        {/* List */}
        <Grid item xs={12} md={4} className={classes.revenueItemsList}>
          <Grid
            style={{ display: "flex", marginTop: "5px" }}
            justifyContent="space-between"
            alignItems="center"
          ></Grid>
          {vehicleList.map((item: any, index: number) => {
            return (
              <>
                {!item.name?.includes("BBF") && (
                  <Grid
                    container
                    direction="row"
                    key={item.vehicleStatus}
                    className={classes.statusItem}
                    style={{
                      backgroundColor: BBFColor[index],
                      borderRadius: "4px",
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                    onClick={() => toggleDialogLevelTwo(item, false)}
                  >
                    <Grid item xs={10}>
                      {item?.isCommercialVehicles ? (
                        <Typography>
                          {item.name}{" "}
                          <span style={{ color: "#e67817" }}>{`(Includes BBF: ${
                            vehicleList.find((item: any) => item.name.includes("BBF"))?.count
                          })`}</span>
                        </Typography>
                      ) : (
                        <Typography>{`${item.name}`}</Typography>
                      )}
                    </Grid>
                    <Grid item xs={2} className={classes.statusAmount}>
                      {item.count}
                    </Grid>
                  </Grid>
                )}
              </>
            );
          })}
        </Grid>
      </Grid>

      <CommonDialog
        isOpen={isOpenDailogLevelTwo}
        handleClose={() => setIsOpenDailogLevelTwo(!isOpenDailogLevelTwo)}
        maxWidth="lg"
        heading={
          <Box display="flex" alignItems="center">
            <Typography className={classes.heading}>{chartHeadeingLevel2?.status}: </Typography>
            <Typography style={{ marginLeft: "10px" }} className={classes.revenueAmount}>
              {chartHeadeingLevel2?.count}
            </Typography>
          </Box>
        }
      >
        <Box className="insightsBarChart" m="auto">
          <Bar
            style={{ minWidth: "100vh", minHeight: "100%" }}
            options={barChartOptionsLevel2}
            data={barChartDataLevel2}
          />
        </Box>
      </CommonDialog>
      <CommonDialog
        isOpen={isOpenDailogLevelThree}
        handleClose={toggleDialogLevelThree}
        maxWidth="lg"
        heading={
          <Box display="flex" alignItems="center">
            <Typography className={classes.heading}>
              {chartHeadeingLevel3?.consignmentType}:{" "}
            </Typography>
            <Typography style={{ marginLeft: "10px" }} className={classes.revenueAmount}>
              {chartHeadeingLevel3?.count}
            </Typography>
          </Box>
        }
      >
        <CommonMaterialGrid
          rows={vehicleRecord}
          columns={displayColumns}
          loader={loader}
          defaultPerPageRecord={15}
          height={550}
          deletedRow={true}
          isExport={isExport}
          exportHandler={exportHandler}
          filename={`List_of_vehicle_${Date.now()}`}
        />
      </CommonDialog>
    </>
  );
}
